<template>
    <div>
        <Table :isEmpty="!processedJobs.length">
            <TableHead>
                <TableHeadCell>ID</TableHeadCell>
                <TableHeadCell>Key</TableHeadCell>
                <TableHeadCell>State</TableHeadCell>
                <TableHeadCell>Queue name</TableHeadCell>
                <TableHeadCell>Releases</TableHeadCell>
                <TableHeadCell>Retries</TableHeadCell>
                <TableHeadCell></TableHeadCell>
            </TableHead>
            <TableBody>
                <ProcessedJobTableRow
                    v-for="(job, index) in processedJobs"
                    :key="index"
                    :job="job"
                    :selectedQueueName="selectedQueueName"
                    :selectedJobState="selectedJobState"
                    :currentPage="currentPage"
                />
            </TableBody>

            <template #emptyState>
                <TableEmptyState title="No jobs found." />
            </template>
        </Table>
    </div>
</template>

<script setup lang="ts">
    import type { PropType } from 'vue'
    import Table from '@/Shared/Component/Table/Table.vue'
    import TableHead from '@/Shared/Component/Table/TableHead.vue'
    import TableHeadCell from '@/Shared/Component/Table/TableHeadCell.vue'
    import TableBody from '@/Shared/Component/Table/TableBody.vue'
    import TableEmptyState from '@/Shared/Component/Table/TableEmptyState.vue'
    import ProcessedJobTableRow from '@/Admin/Queue/Component/ProcessedJobTableRow.vue'
    import type { ProcessedQueueJobData } from '@/Shared/AutoGenerated/Main'

    const props = defineProps({
        processedJobs: {
            type: Array as PropType<ProcessedQueueJobData[]>,
            required: true,
        },
        selectedQueueName: {
            type: String,
            required: true,
        },
        selectedJobState: {
            type: String,
            required: true,
        },
        currentPage: {
            type: Number,
            required: true,
        },
    })
</script>
